import {
    ScenarioProject,
    ScenarioResults
} from "in_queue/types/scenarioResultType";

export const countUpgrades = (
    results: ScenarioResults,
    projectId: string
): number =>
    results.allocatedUpgrades.filter((u) => u.projectId === projectId).length;

// Count only the projects this scenario actually dispatched. The
// `results.projects` array carries every project in the cluster, including
// ones dropped via the scenario assumptions (size reduced to 0 MW), so the
// raw length is the full roster and is identical across scenarios. A project
// is "dispatched" when it has nonzero ERIS or NRIS size — the same definition
// CompareScenariosPage uses to flag excluded projects.
export const totalProjects = (results: ScenarioResults): number =>
    results.projects.filter((p) => p.erisSizeMw > 0 || p.nrisSizeMw > 0).length;

export const averageAllocatedCostPerProject = (
    results: ScenarioResults
): number => {
    if (results.projects.length === 0) {
        return 0;
    }
    const total = results.projects.reduce(
        (sum, p) => sum + p.sumAllocatedCost,
        0
    );
    return total / results.projects.length;
};

export const averageCostPerMw = (results: ScenarioResults): number | null => {
    const defined = results.projects.filter(
        (p): p is ScenarioProject & { costPerMw: number } => p.costPerMw != null
    );
    if (defined.length === 0) {
        return null;
    }
    const total = defined.reduce((sum, p) => sum + p.costPerMw, 0);
    return total / defined.length;
};

export const totalAssignedUpgrades = (results: ScenarioResults): number =>
    results.allocatedUpgrades.length;

export const averageAssignedUpgradesPerProject = (
    results: ScenarioResults
): number =>
    results.projects.length === 0
        ? 0
        : results.allocatedUpgrades.length / results.projects.length;

export const totalConstraints = (results: ScenarioResults): number =>
    results.constraints.length;

export const averageConstraintsPerProject = (
    results: ScenarioResults
): number =>
    results.projects.length === 0
        ? 0
        : results.constraints.length / results.projects.length;
